import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary';
import { StudentDashboardTab } from '@features/student-page/components/StudentDashboardTab';
import { studentInfoQueryOptions } from '@features/student-page/queries';
import { studentAbsencesQueryOptions } from '@features/student-page/sub-features/student-absences/queries';
import { studentCurrentLessonQueryOptions } from '@features/student-page/sub-features/student-current-lesson/queries';
import { studentMonthAttendanceQueryOptions } from '@features/student-page/sub-features/student-month-attendance/queries';
import { studentSupportOrbitQueryOptions } from '@features/student-page/sub-features/student-support-orbit/queries';
import { studentTeachersQueryOptions } from '@features/student-page/sub-features/student-teachers/queries';
import { studentYearPeriodAttendanceQueryOptions } from '@features/student-page/sub-features/student-year-period-attendance/queries';
import { studentTimetableQueryOptions } from '@features/timetables/queries';
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator';
import { Suspense } from 'react';

export const Route = createFileRoute('/_layout/students/$studentNo/')({
    loader: ({ params, context }) => {
        void Promise.all([
            context.queryClient.ensureQueryData(studentInfoQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentCurrentLessonQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentTimetableQueryOptions({ studentNo: Number(params.studentNo) })),
            context.queryClient.ensureQueryData(studentAbsencesQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentTeachersQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentSupportOrbitQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentYearPeriodAttendanceQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentMonthAttendanceQueryOptions(params.studentNo)),
        ])
    },
    component: RouteComponent,
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title='Failed to load student dashboard'>
            <Suspense fallback={<LoadingIndicator resource='student dashboard' />}>
                <StudentDashboardTab studentNo={studentNo}/>
            </Suspense>
        </QueryErrorBoundary>
    )
}
